import type { ReactNode } from 'react';
import type { TabItem } from '@ics-portal/guardian';
import { InfoTabIcon } from '@components/_atoms/icons';
import InfoCardWrapper from './Layout/InfoCardWrapper';
import { TabbedInfoCard } from './TabbedInfoCard';

export interface EmptyInfoCardProps {
    title?: string;
    description?: string;
    tabName?: string;
    icon?: ReactNode;
}

export function EmptyInfoCard({
    title = 'No item selected',
    description = 'Please select a row from the table to view details here.',
    tabName = 'Details',
    icon = <InfoTabIcon />,
}: EmptyInfoCardProps): ReactNode {
    const tabItems: TabItem[] = [
        {
            name: tabName,
            icon,
            tooltip: tabName,
            content: (
                <InfoCardWrapper title={title}>
                    <p className="m-0">{description}</p>
                </InfoCardWrapper>
            ),
        },
    ];

    return <TabbedInfoCard tabItems={tabItems} />;
}

export default EmptyInfoCard;
